<div class="checkbox-wrapper-1">
  <input
    class="substituted"
    type="checkbox"
    aria-hidden="true"
    [formControl]="checkBoxControl"
  />
  <label for="example-1">{{ label }}</label>
</div>
